export enum EnumUsuarioPerfil {
  ATENDENTE = 4,
  GERENTE = 3,
  REPRESENTANTE = 2
}
